import {SERVICE_URL} from "./app.const";
import axios from "axios";

const GET_TOKEN = SERVICE_URL + '/authenticate'

const GET_PROFILE = SERVICE_URL + '/profile/me'

const REGISTER_PROFILE = SERVICE_URL + '/profile/register'

export async function registerUser(userForm) {
    try {
        await axios.post(REGISTER_PROFILE, userForm, {
            headers: { "Content-Type": "application/json" }
        });
        return { isError: false };
    } catch (error) {
        return {
            isError: true,
            status: error?.response?.status ?? null,
            message: error?.response?.data?.message ?? error?.response?.data ?? error?.message
        };
    }
}

export async function fetchToken(userForm){
    try {
        const response = await axios.post(GET_TOKEN, userForm);
        return response.data;
    } catch (error) {
        if ([400, 401, 403, 404].includes(error?.response?.status)) {
            return undefined;
        }
        throw error;
    }
}

export async function fetchUser(token){
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    try {
        const response = await axios.get(GET_PROFILE, config);
        return response.data;
    } catch {
        return undefined;
    }
}
